import React from 'react';
import LuckyWheel from './LuckyWheel';

function App() {
  return (
    <div className="App">
      <LuckyWheel />
    </div>
  );
}

export default App;